import React, { PureComponent } from 'react'
import Modal from '@active/react-ui/Modal'
import ModalBody from '@active/react-ui/ModalBody'
import ModalFooter from '@active/react-ui/ModalFooter'
import { func, string } from 'prop-types'
import MFAContent from '../../../common/MFAContent'
import I18nMessage from '../../../common/I18nMessage'
import './Verification.scss'

class Verification extends PureComponent {
  static propTypes = {
    onClose: func.isRequired,
    onRequestCode: func.isRequired,
    onVerify: func.isRequired,
    configureTrack: func.isRequired,
    senderEmail: string.isRequired,
    senderPhone: string,
    nextTimeWindow: string.isRequired,
    channel: string,
    message: string,
    epid: string, // Only in Signin.js
  }

  static defaultProps = {
    epid: undefined,
    senderPhone: undefined,
    channel: undefined,
    message: undefined,
  }

  render() {
    const {
      onClose, onRequestCode, onVerify,
      configureTrack, senderEmail, senderPhone, nextTimeWindow, message, epid, channel,
    } = this.props

    return (
      <Modal
        shown
        autoFocusClose
        className="passport-ui-app__modal passport__signin__verification__modal"
        onClose={onClose}
        title={<I18nMessage id="passport.verification.modal.title" />}
        size="md"
      >
        <MFAContent
          onClose={onClose}
          configureTrack={configureTrack}
          onRequestCode={onRequestCode}
          onVerify={onVerify}
          senderEmail={senderEmail}
          senderPhone={senderPhone}
          nextTimeWindow={nextTimeWindow}
          message={message}
          epid={epid}
          channel={channel}
          renderModel="WIDGET_RENDER"
          isShowCancelBtn
          Body={ModalBody}
          Footer={ModalFooter}
        />
      </Modal>
    )
  }
}

export default Verification
